







































import { defineComponent } from '@vue/composition-api';

import AvailableVehicleDisplay from '@/components/Driver/AvailableVehicleDisplay.vue';

import useAuth from '@/useAuth';

const DriverObject = defineComponent({
  props: {
    id: { default: -1 },
    name: { default: '' },
    avatarUrl: { default: '' },
    employeeCode: { default: '' },
    availableVehicleType: { default: 0 },
    recentWorkDate: { default: '-' },
    recentMonthCashFlow: { default: 0 },
    primaryTelephone: { default: '' },
    secondaryTelephone: { default: '' },
  },
  components: { AvailableVehicleDisplay },
  setup() {
    const { me } = useAuth();
    return { me };
  },
});

export default DriverObject;
